import { Grid, Button, Divider, Box } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { generalInfoCategories } from './constants/general-info-constants';
import ProjectDescription from './general-info-forms/ProjectDescription';
import BusinessAsUsualForFeedstock from './general-info-forms/BusinessAsUsualForFeedstock';
import BiocharAndWaterSupplyEquipment from './general-info-forms/BiocharAndWaterSupplyEquipment';
import FeedstockSource from './general-info-forms/FeedstockSource';
import BurnSupervisor from './general-info-forms/BurnSupervisor';
import ProjectStakeholders from './general-info-forms/ProjectStakeholders';
import EntityDetails from './general-info-forms/EntityDetails';

export default function GeneralInfo() {
    const [selectedCategory, setSelectedCategory] = useState('Project Description');
    const { selectedProject } = useSelector((state) => (state.postFormData));
    const { id: projectId } = selectedProject || {} //measureType

    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {generalInfoCategories.map((generalInfoCategory, index) => (
                    <Button
                        key={index}
                        onClick={() => setSelectedCategory(generalInfoCategory)}
                        variant={selectedCategory === generalInfoCategory ? 'contained' : 'outlined'}
                    >
                        {generalInfoCategory}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {
                    selectedCategory === 'Project Description' &&
                    <ProjectDescription projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Business as Usual for Feedstock' &&
                    <BusinessAsUsualForFeedstock projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Biochar and Water Supply Equipment' &&
                    <BiocharAndWaterSupplyEquipment projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Feedstock Source' &&
                    <FeedstockSource projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Burn Supervisor' &&
                    <BurnSupervisor projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Project Stakeholders' &&
                    <ProjectStakeholders projectId={projectId} selectedCategory={selectedCategory} />
                }
                {
                    selectedCategory === 'Entity Details' &&
                    <EntityDetails projectId={projectId} selectedCategory={selectedCategory} />
                }
            </Box>
        </Grid>
    );
}
